module.exports = __webpack_public_path__ + "img/fifa21.7e3dfb30.png";